import { Capacitor } from "@capacitor/core"

/**
 * Capacitor Preferences プラグインが利用可能かどうかを判定する。
 *
 * ネイティブプラットフォーム（iOS/Android）でのみ true を返す。
 * Web では Preferences は使用できないため false を返す。
 *
 * isPluginAvailable() も確認するのは、Capgo LiveUpdate で古いネイティブバイナリに
 * 新しい JS バンドルが配信された場合に Preferences プラグインが存在しない可能性があるため。
 */
export const isPreferencesAvailable = () =>
    Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("Preferences")
